/**
 * Whether the mandate, library and proposal pages are switched on.
 *
 * This is NOT a staged rollout gate waiting on unbuilt endpoints -- all three
 * real backends (/api/mandates, /api/library, /api/proposals, the latter via
 * W7.1's ReplicationRunSleeveHistory) have been live and unconditionally
 * wired on main since 2026-09-30/10-01 (PRs #186/#191). `ff_mandate_v1`
 * itself has defaulted to `true` in production since PR #186 (2026-10-01)
 * and is kept only as a per-browser emergency kill switch (localStorage
 * `ff:ff_mandate_v1=false`) -- the same pattern this file's sibling
 * `feature-flags.ts` uses for `ff_data_heartbeat`/`ff_strategy_vitals`/
 * `ff_research_side_pane` once each of those rollouts completed. Flipping it
 * off locally also still exercises real, tested legacy behavior (AppShell's
 * original pre-mandate onboarding guard, OnboardingPage's pre-mandate copy),
 * which is why the flag is kept rather than deleted outright. In mock mode
 * (`useMockApi()`) the UI is unconditionally on regardless of this flag, same
 * as every other mocked page.
 */

import { useMockApi } from '../config';
import { isFeatureEnabled } from '../lib/feature-flags';

export function isMandateUiEnabled(): boolean {
  return useMockApi() || isFeatureEnabled('ff_mandate_v1');
}
